'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVal = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getVal = exports.getVal = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var fieldName, fieldCode, list;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fieldName = params.fieldName, fieldCode = params.fieldCode;
            _context.prev = 1;
            _context.next = 4;
            return (0, _service._api_reception_executeUsingPost)({
              actionCode: 'FieldValueRecommend',
              data: JSON.stringify({
                fieldName: fieldName,
                fieldCode: fieldCode
              }),
              sequenceNo: (0, _formFieldUtils.getQuery)().sequenceNo,
              viewId: 'Form'
            });

          case 4:
            list = _context.sent;
            return _context.abrupt('return', list);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);
            throw _context.t0;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 8]]);
  }));

  return function getVal(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = SmartInput;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _service = require('./service');

var _formFieldUtils = require('../formFieldUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function SmartInput(props) {
  var fieldName = props.fieldName,
      onChange = props.onChange,
      value = props.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      executing = _useState2[0],
      setExecuting = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      fieldVal = _useState6[0],
      setFieldVal = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      recommendList = _useState8[0],
      setCommendList = _useState8[1];

  var getData = function getData() {
    if (executing) {
      return;
    }
    setExecuting(true);

    getVal(props).then(function (data) {
      if (!(0, _lodash.isArray)(data)) {
        return;
      }
      if (data.length === 0) {
        _next.Message.notice('暂无推荐值');
        return;
      }
      if (data.length === 1) {
        onChange((0, _lodash.head)(data));
        return;
      }
      // aone.alibaba-inc.com/v2/project/1061355/bug/40206911
      setVisible(true);
      setCommendList(data);
    }).finally(function () {
      setExecuting(false);
    });
  };

  var onOk = function onOk() {
    onChange(fieldVal);
    // 关闭弹窗
    setVisible(false);
  };

  var onClose = function onClose() {
    // 重置值
    setFieldVal(value);
    setVisible(false);
  };
  // 外面的值影响到里面
  (0, _react.useEffect)(function () {
    setFieldVal(value);
  }, [value]);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _next.Button,
      { type: 'secondary', className: 'vc-trigger-request-btn', onClick: getData },
      props.writeBtn
    ),
    _react2.default.createElement(
      _next.Dialog,
      { visible: visible, onClose: onClose, onOk: onOk, onCancel: onClose },
      _react2.default.createElement(
        _next.Typography.H6,
        null,
        '\u68C0\u6D4B\u5230\u60A8\u4FDD\u5B58\u4E86\u591A\u6761',
        fieldName,
        '\u7684\u4FE1\u606F\uFF0C\u8BF7\u9009\u62E9\u672C\u6B21\u4F60\u8981\u4F7F\u7528\u7684\u4FE1\u606F'
      ),
      _react2.default.createElement(
        _next.Radio.Group,
        {
          direction: 'ver',
          value: fieldVal,
          onChange: function onChange(v) {
            setFieldVal(v);
          }
        },
        !(0, _lodash.isEmpty)(recommendList) && recommendList.map(function (v, index) {
          return _react2.default.createElement(
            _next.Radio,
            { key: v, value: v },
            fieldName + ' ' + (index + 1),
            ': ',
            v
          );
        })
      )
    )
  );
}